// Material 3 Floating Action Button (+ extended when `label` is given)
// Props: icon (node), label, size ('small' 40 | 'medium' 56 | 'large' 96), tone ('primary' | 'secondary' | 'tertiary' | 'surface')
(function () {
  const { Fab: MuiFab } = MaterialUI;

  const TONES = {
    primary: ['var(--m3-primary-container)', 'var(--m3-on-primary-container)'],
    secondary: ['var(--m3-secondary-container)', 'var(--m3-on-secondary-container)'],
    tertiary: ['var(--m3-tertiary-container)', 'var(--m3-on-tertiary-container)'],
    surface: ['var(--m3-surface-container-high)', 'var(--m3-primary)']
  };
  const SIZES = { small: [40, 'var(--m3-shape-medium)'], medium: [56, 'var(--m3-shape-large)'], large: [96, 'var(--m3-shape-extra-large)'] };

  const Fab = React.forwardRef(function Fab({ icon, label, size = 'medium', tone = 'primary', sx = {}, ...props }, ref) {
    const [bg, fg] = TONES[tone] || TONES.primary;
    const [dim, radius] = SIZES[size] || SIZES.medium;
    return (
      <MuiFab
        ref={ref}
        variant={label ? 'extended' : 'circular'}
        disableRipple
        aria-label={props['aria-label'] || label}
        sx={{
          height: dim,
          minHeight: dim,
          width: label ? 'auto' : dim,
          px: label ? 2 : 0,
          gap: 1,
          borderRadius: radius,
          textTransform: 'none',
          font: 'var(--m3-type-label-large)',
          backgroundColor: bg,
          color: fg,
          boxShadow: 'var(--m3-elevation-3)',
          transition: 'box-shadow var(--m3-duration-short) var(--m3-easing-standard)',
          '&:hover': {
            backgroundColor: `color-mix(in srgb, ${fg} 8%, ${bg})`,
            boxShadow: 'var(--m3-elevation-4, var(--m3-elevation-3))'
          },
          '&:active': { backgroundColor: `color-mix(in srgb, ${fg} 10%, ${bg})` },
          '&.Mui-focusVisible': { outline: '3px solid var(--m3-secondary)', outlineOffset: 2 },
          ...sx
        }}
        {...props}
      >
        {icon}
        {label}
      </MuiFab>
    );
  });

  window.Components = window.Components || {};
  window.Components.Fab = Fab;
})();
